var map = {
	"./boo.wav": 8061,
	"./ding ding ding.mp3": 4143,
	"./foghorn.mp3": 9590,
	"./hells kitchen sound.mp3": 8136,
	"./incorrect buzzer.mp3": 8382,
	"./laugh track.wav": 8331,
	"./sitcom sound.wav": 2829,
	"./whomp whomp.mp3": 5077,
	"./woosh.wav": 4265
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7769;